import { quickOrderPageContainerStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderPageContainer";
import { css } from "styled-components";

Object.assign(quickOrderPageContainerStyles, {
    leftColumnGridItem: {
        css: css`
            display: none;
        `,
    },
    rightColumnGridItem: { width: [0, 0, 12, 12, 12] },
});
